import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { isNativeApp } from "./lib/isNativeApp";

// Initialize PDF.js worker BEFORE any component renders
import "./lib/pdfConfig";

// Register service worker for web push notifications (desktop only)
if (!isNativeApp() && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("ServiceWorker registration successful:", registration.scope);
      })
      .catch((error) => {
        console.log("ServiceWorker registration failed:", error);
      });
  });
}

// Global error logging to avoid silent white screens (especially in native WebView)
window.addEventListener("error", (event) => {
  console.error("[GlobalError]", event.error || event.message, {
    filename: (event as any).filename,
    lineno: (event as any).lineno,
    colno: (event as any).colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("[UnhandledRejection]", event.reason);
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
